<div class="container" style="max-width: 100%;">
    <H1>Reallocation to Agent</H1>
  
    <div *ngIf="firstscreen">
      <div class="row" style="justify-content: center;">
        <div class="col-2">
          <div class="form-group">
            <label>Agent:</label>
            <div class="input-group mb-3">
              <select class="form-control" name="Agent" type="text" [(ngModel)]="Agent" required 
                placeholder="Enter Agent">
                <option *ngFor="let tempAgent of AgentsData; let i =index" value={{i}}>{{tempAgent.Code + "-" + tempAgent.Name + " "+ tempAgent.Surname}}
                </option>
              </select>
            </div>
          </div>
  
          <div class="form-group" >
            <label>Date Issued:</label>
            <div class="input-group mb-3">
              <input class="form-control" name="date"  type="date"  [(ngModel)]="date" required placeholder="Select a date" max={{CurrentDate}}/>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row" style="justify-content: space-evenly;">
        <div class="col-4">
          <div class="form-group">
            <label>Enter Box Number:</label>
            <input class="form-control" name="BoxNumber" type="text" [(ngModel)]="BoxNumber" required
              placeholder="Enter Box Number" maxlength="30" (ngModelChange)="BoxNameChanged()" autocomplete="off"/>
  
            <label style="margin-top: 20px;">Exsisting Boxes:</label>
            <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;"
              [(ngModel)]="PossibleBox" (change)="PossibleBoxChanged()">
              <option *ngFor="let item of PossibleBoxNumbers; let i =index" value={{item}}>{{item}}
              </option>
            </select>
          </div>
  
          <div class="form-group" style="display: inline-flex;">
            <div style="float: left;margin-right: 20px;margin-left:20px;">
              <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="RemoveBox()">Remove Box</button>
            </div>
  
            <div style="float: right;margin-left:20px;">
              <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!BoxNumber"
                (click)="AddBox()">Add Box</button>
            </div>
          </div>
  
          <div class="form-group">
            <label>Selected Boxes</label>
            <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;"
              [(ngModel)]="PossibleBox" (change)="PossibleBoxChanged()">
              <option *ngFor="let item of SelectedBoxNumbers; let i =index" value={{item}}>{{item}}
              </option>
            </select>
          </div>
        </div>
  
        <div class="col-4">
          <div class="form-group">
            <label>Enter Brick Number:</label>
            <input class="form-control" name="BrickNumber" type="text" [(ngModel)]="BrickNumber" required
              placeholder="Enter brick Number" maxlength="30" (ngModelChange)="BrickNumberChanged()" autocomplete="off"/>
  
            <label style="margin-top: 20px;">Exsisting Bricks:</label>
            <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;"
              [(ngModel)]="PossibleBrick" (change)="PossibleBrickChanged()">
              <option *ngFor="let item of PossibleBrickNumbers; let i =index" value={{item}}>{{item}}
              </option>
            </select>
          </div>
  
          <div class="form-group" style="display: inline-flex;">
            <div style="float: left;margin-right: 20px;margin-left:20px;">
              <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="RemoveBrick()">Remove Bricks</button>
            </div>
  
            <div style="float: right;margin-left:20px;">
              <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!BrickNumber"
                (click)="AddBrick()">Add Bricks</button>
            </div>
          </div>
  
          <div class="form-group">
            <label>Selected Bricks</label>
            <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;"
              [(ngModel)]="PossibleBrick" (change)="PossibleBrickChanged()">
              <option *ngFor="let item of SelectedBrickNumbers; let i =index" value={{item}}>{{item}}
              </option>
            </select>
          </div>
        </div>
  
      </div>
  
  
  
  
  
      <div class="form-group  form-button-div">
  
        <div style="float: left;margin-right: 20px;margin-left:20px;">
          <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
        </div>
  
        <div style="float: right;margin-left:20px;">
          <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!date"
            (click)="Next()">Next</button>
        </div>
  
      </div>
  
  
  
  
    </div>
  
  
  </div>
  
  
  
  <!--Error popup-->
  <div style="float: right;margin-left:20px;">
    <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
    </button>
  
    <button class="btn btn-success btn-lg btn-block" id="ErrorButtonConstant" (click)="open2(content)"
      style="display: none;">
    </button>
  </div>
  <ng-template #content let-modal ID="Errormessage">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{PopupTitle}}
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  
        <span aria-hidden="true">
  
        </span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="dateOfBirth">
            {{DisplayErrormessage}}
          </label>
        </div>
  
  
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
        Done
      </button>
  
  
    </div>
  </ng-template>
  
  
  <ng-template #content2 let-modal ID="ConfirmReset">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{PopupTitle}}
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  
        <span aria-hidden="true">
          X
        </span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="dateOfBirth">
            {{DisplayErrormessage}}
          </label>
  
          <div class="form-group">
            <input class="form-control" name="ConfirmReset" type="text" [(ngModel)]="ConfirmReset" required placeholder=""
              maxlength="30" />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
        Done
      </button>
  
      <button type="button" class="btn btn-warning btn-lg btn-block" (click)="modal.close('Cancel')">
        Cancel
      </button>
    </div>
  </ng-template>